/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const BackToTopIcon = ({ className }) => (
  <svg
    className={className}
    width="45px"
    height="45px"
    viewBox="0 0 400 400"
    version="1.2"
    baseProfile="tiny"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      fill="#FFF"
      fillOpacity=".9"
      d="M37.3 6.8h325.4v386.4H37.3z"
    />
    <path
      fill="#D5980C"
      d="M369.5 400h-339V0h339v400zM44.1 386.4H356V13.6H44.1v372.8z"
    />
    <path
      fillRule="evenodd"
      fill="#D5980C"
      d="M153.8 302c-1.7 1.7-1.7 4.4 0 6.1 1.7 1.7 4.4 1.7 6.1 0l35.8-35.8c1.4-1.2 3.2-2.1 4.8-2.1s2.6 1 3.8 2.1l35.8 35.8c1.7 1.7 4.4 1.7 6.1 0 .8-.8 1.3-1.9 1.3-3.1 0-1.1-.4-2.2-1.3-3.1l-43.1-43.1c-1.7-1.7-4.4-1.7-6.1 0L153.8 302z"
    />
    <g fill="#002967">
      <path d="M150.7 125v64.8h-11.4V125h-22.1v-11.2h55.7V125h-22.2zM195.5 191c-14.3 0-25.1-11.8-25.1-29.6 0-18.7 11.1-29.7 25.4-29.7 14.5 0 25.4 11.6 25.4 29.4 0 18.9-11.1 29.9-25.7 29.9zm-.1-48.7c-8.5 0-13.7 7.5-13.7 18.8 0 12.5 5.8 19.3 14.2 19.3s14-8.6 14-19c0-11.6-5.5-19.1-14.5-19.1zM260.4 191c-5.8 0-11.2-3-14.3-6.5V205l-11.1 5.7v-77.9h11v5.4c4.1-3.8 8.9-6.6 14.9-6.6 12.3 0 21.9 8.9 21.9 30.6 0 19.6-10.6 28.8-22.4 28.8zm-1.5-49c-5.3 0-10 3.6-12.9 7.3v24c2.5 3.4 7.7 7.5 13.3 7.5 8 0 12.4-6.1 12.4-18.1 0-14.4-4.6-20.7-12.8-20.7z" />
    </g>
  </svg>
);

export default BackToTopIcon;
